import callAPI from '../../../API/callSecureAPI'
import endpoints from '../../../API/endpoints'
import { ValueNarrative } from './useGetValueNarrativesQuery'
import { useAuth0 } from '../../../contexts/auth0-context'
import { useMutation } from 'react-query'
import { useInvalidateGetValueNarrativesQuery } from './useInvalidateGetValueNarrativesQuery'
import { useInvalidateGetCommentsQuery } from '../../../shared/components/Comments/useCommentsQueries'
import { useSelector } from 'react-redux'
import useEventLogger from '../../../shared/hooks/useEventLogger'

type UseTransferValueNarrativeMutationProps = {
    onTransferValueNarrative?: () => void
}

export const useTransferValueNarrativeMutation = ({
    onTransferValueNarrative,
}: UseTransferValueNarrativeMutationProps) => {
    const { getTokenSilently } = useAuth0()
    const { logEvent, ACTIONS } = useEventLogger()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const { invalidateGetCommentsQuery } = useInvalidateGetCommentsQuery()

    const transferValueNarrative = async (valueNarrative: Pick<ValueNarrative, '_id' | 'categoryId'>) => {
        try {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.transferValueNarrative

            const response = await callAPI(url + valueNarrative._id, method, token, {
                targetCategoryId: valueNarrative.categoryId,
            })

            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    const { invalidateGetValueNarrativesQuery } = useInvalidateGetValueNarrativesQuery()

    return useMutation(transferValueNarrative, {
        onSuccess: async (_, valueNarrative) => {
            logEvent(ACTIONS.TRANSFER, {
                type: 'VALUE_NARRATIVE',
                narrativeId: valueNarrative._id,
                targetCategoryId: valueNarrative.categoryId,
            })
            await invalidateGetValueNarrativesQuery()
            invalidateGetCommentsQuery(valueNarrative._id)
            invalidateGetCommentsQuery(strategyId)
            onTransferValueNarrative?.()
        },
    })
}
